module.exports = __webpack_public_path__ + "img/adv_ins_2.d83e2f69.png";